import { createFileRoute } from "@tanstack/react-router";
import { EditReceptionPage } from "@/features/achats/components/receptions/EditReceptionPage";

export const Route = createFileRoute("/_app/achats/receptions/$id/edit")({
  staticData: {
    title: "Modifier bon de réception",
    showInBreadcrumb: true,
  },
  component: EditReceptionPage,
});
